export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  ORG_ADMIN: 'org_admin',
  ORG_USER: 'org_user',
  USER: 'app-user',
} as const;

export type Role = typeof ROLES[keyof typeof ROLES]; 

// Role translation keys map
export const ROLE_TRANSLATION_KEYS = {
  [ROLES.SUPER_ADMIN]: 'SUPER_ADMIN',
  [ROLES.ADMIN]: 'ADMIN',
  [ROLES.ORG_ADMIN]: 'ORG_ADMIN', 
  [ROLES.ORG_USER]: 'ORG_USER',
  [ROLES.USER]: 'USER',
} as const;

// Helper function to get translation key for a role
export const getRoleTranslationKey = (role: string): string => {
  return ROLE_TRANSLATION_KEYS[role as Role] || role;
}; 